/* hs-eslint ignored failing-rules */

import get from 'transmute/get';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UICloseButton from 'UIComponents/button/UICloseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { STATUS_SYNC_INFO as promptType } from '../../contextual-prompts/constants/promptTypes';
// @ts-expect-error Not typed

// @ts-expect-error Not typed
import { fetchPromptData } from '../../contextual-prompts/clients/fetchPromptData';
// @ts-expect-error Not typed
import { promptWasShown } from '../../contextual-prompts/clients/promptWasShown';
// @ts-expect-error Not typed
import { dismissPrompt } from '../../contextual-prompts/clients/dismissPrompt';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCloseButton = styled(UICloseButton).withConfig({
  displayName: "TicketStatusLabel__StyledCloseButton",
  componentId: "twzceu-0"
})(["position:absolute;top:10px;right:10px;"]);
const TicketStatusLabel = () => {
  const {
    onDismissToolTip,
    showTicketTabToolTip
  } = TicketStatusLabel.useComponent();
  return /*#__PURE__*/_jsx(UITooltip, {
    maxWidth: 325,
    use: "longform",
    placement: "left",
    open: showTicketTabToolTip,
    headingText: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledCloseButton, {
        color: "#99acc2",
        size: "medium",
        onClick: onDismissToolTip
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-toolbar.ticketStatus.tooltipHeader"
      })]
    }),
    title: /*#__PURE__*/_jsx("p", {
      style: {
        fontSize: '14px'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.thread-toolbar.ticketStatus.tooltipContent"
      })
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.thread-toolbar.ticketStatus.ticketStatusLabel"
    })
  });
};
const useTicketStatusToolTip = () => {
  const [showTicketTabToolTip, setShowTicketTabToolTip] = useState(false);
  useEffect(() => {
    fetchPromptData({
      promptType
    }).then(data => {
      const isFirstTimeViewed = get('viewedCount', data) === 0;
      const hasBeenDismissed = get('dismissedAt', data) !== 0;
      if (isFirstTimeViewed) promptWasShown({
        promptType
      });
      if (hasBeenDismissed) {
        setShowTicketTabToolTip(false);
      } else {
        setShowTicketTabToolTip(true);
      }
    }).catch(err => {
      reportError({
        error: new Error(`Failed to fetch prompt data: ${err.message}`),
        extra: {
          error: err
        },
        tags: {
          isVisibleToUser: true
        }
      });
    });
  }, []);
  const onDismissToolTip = () => {
    setShowTicketTabToolTip(false);
    dismissPrompt({
      promptType
    });
  };
  return {
    onDismissToolTip,
    showTicketTabToolTip
  };
};
TicketStatusLabel.useComponent = useTicketStatusToolTip;
TicketStatusLabel.displayName = 'TicketStatusLabel';
export default TicketStatusLabel;